export default {

 url_service: "https://services.celcom.cl",
 login: "/rest/protected/user/authenticate?TOKEN=",
  upload_file_url: "/rest/public/uploadFileUrl",

  // Modulos Contacto
  contact_available: "/rest/protected/contact/available",
  contact_available_contact: "/rest/protected/contact/available/contact",
  contact_available_contact_preview: "/rest/protected/contact/available/contact_preview",
  contact_edit_contact: "/rest/protected/contact/edit/contact",
  contact_delete_contact: "/rest/protected/contact/delete/contact",
  contact_edit_contact_group: "/rest/protected/contact/edit/contact_group",
  contact_delete_contact_group: "/rest/protected/contact/delete/contact_group",
  contact_add_contact: "/rest/protected/contact/add/contact",
  contact_add_contacts: "/rest/protected/contact/add/contacts",
  contact_add_contact_group: "/rest/protected/contact/add/contact_group",
  // Modulos Envios
  sending_sms_create_edit: "/rest/protected/sending_sms/create_edit",
  sending_sms_send: "/rest/protected/sending_sms/send",
  sending_sms_available: "/rest/protected/sending_sms/available",
  sending_sms_abort: "/rest/protected/sending_sms/abort",
  sending_sms_get: "/rest/protected/sending_sms/get",


  // Modulos sms-link
  landing_available: "/rest/protected/lading/available",
  landing_show: "/rest/protected/lading/show",
  landing_delete: "/rest/protected/lading/delete",

  // Modulos Drafts
  draft_available: "/rest/protected/draft/available",
  draft_edit: "/rest/protected/draft/edit",
  draft_add: "/rest/protected/draft/add",
  draft_delete: "/rest/protected/draft/delete",
  // Modulos Reportes
  report_available: "/rest/protected/report/available",
  report_log: "/rest/protected/report/logs",
  report_excel_report: "/protected/report/excel_report?TOKEN=",
  report_excel_report_mo: "/protected/report/excel_report_mo?TOKEN=",
  report_mo_report: "/rest/protected/report/mo_report",
  // Modulos Blacklist
  blacklist_available: "/rest/protected/blacklist/available",
  blacklist_add_blacklist: "/rest/protected/blacklist/add/blacklist",
  blacklist_add_blacklists: "/rest/protected/blacklist/add/blacklists",
  blacklist_delete_blacklist: "/rest/protected/blacklist/delete/blacklist",
  // Modulos Costumer User
  costumer_user_available: "/rest/protected/customer_user/available",
  costumer_user_edit: "/rest/protected/customer_user/edit",
  costumer_user_add: "/rest/protected/customer_user/add",
  customer_user_detele:"/rest/protected/customer_user/delete",
  customer_user_access:"/rest/protected/customer_user/access",
  customer_user_access_edit:"/rest/protected/customer_user/access/edit",
  //Modulos Payment
  payment_products: "/rest/protected/payment/products",
  payment_plataforms: "/rest/protected/payment/platform",
  payment_init_payment: "/rest/protected/payment/init_payment",
  payment_gettransaction: "/rest/protected/payment/getTransaction",
  //Modulos Languages
  language_available:"/rest/protected/language/available",
  //Modulos Country
  country_available:"/rest/protected/country/available",
  //Modulos UDH Credits
  udh_validate_credits:"/rest/protected/sending_sms/udh_validate_credits",
  //Modulos Time Serve
  time_serve:"/rest/protected/statistics/time_serve",
}
